import AdminDevicesSection from '../../components/admin/AdminDevicesSection'
import AdminHeader from '../../components/admin/AdminHeader'
import { useTheme } from '../../themes/ThemeProvider'

export default function DevicesPage() {
  const { currentTheme } = useTheme()
  const isImmersive = currentTheme.id === 'immersive'

  return (
    <div className={isImmersive ? '' : 'min-h-screen bg-gray-50'}>
      <AdminHeader />
      <div className={isImmersive ? 'p-6' : 'py-8'}>
        <div className={isImmersive ? '' : 'max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'}>
          <AdminDevicesSection />
        </div>
      </div>
    </div>
  )
}
